/**
 * @generated SignedSource<<06d4dfb9b81a2fad8a6d8093deac6320>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RenameFeatureFlagCohortInput = {
  cohortId?: string | null;
  name?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type renameFeatureFlagCohortMutation$variables = {
  input: RenameFeatureFlagCohortInput;
};
export type renameFeatureFlagCohortMutation$data = {
  readonly RenameFeatureFlagCohort: {
    readonly missionControlData: {
      readonly id: string;
      readonly featureFlagLists: {
        readonly id: string;
        readonly cohorts: ReadonlyArray<{
          readonly id: string;
          readonly cohortId: number | null;
          readonly name: string | null;
          readonly companyIds: ReadonlyArray<number | null> | null;
        } | null> | null;
        readonly alwaysLastCompanyIds: ReadonlyArray<number | null> | null;
      } | null;
    } | null;
  } | null;
};
export type renameFeatureFlagCohortMutation = {
  variables: renameFeatureFlagCohortMutation$variables;
  response: renameFeatureFlagCohortMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RenameFeatureFlagCohortPayload",
    "kind": "LinkedField",
    "name": "RenameFeatureFlagCohort",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MissionControlDataType",
        "kind": "LinkedField",
        "name": "missionControlData",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MissionControlFeatureFlagListsType",
            "kind": "LinkedField",
            "name": "featureFlagLists",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MissionControlFeatureFlagCohortType",
                "kind": "LinkedField",
                "name": "cohorts",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cohortId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "companyIds",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alwaysLastCompanyIds",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "renameFeatureFlagCohortMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "renameFeatureFlagCohortMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "735f27d993120bf40034201386c9fa74",
    "id": null,
    "metadata": {},
    "name": "renameFeatureFlagCohortMutation",
    "operationKind": "mutation",
    "text": "mutation renameFeatureFlagCohortMutation(\n  $input: RenameFeatureFlagCohortInput!\n) {\n  RenameFeatureFlagCohort(input: $input) {\n    missionControlData {\n      id\n      featureFlagLists {\n        id\n        cohorts {\n          id\n          cohortId\n          name\n          companyIds\n        }\n        alwaysLastCompanyIds\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2c83b6b44e28f95874d60aca4f5a937e";

export default node;
